const PATH_PREFIX = '/company/:origin/:companySlug';

export default [
  {
    name: 'company.index',
    path: `${PATH_PREFIX}/`,
  },
  {
    name: 'company.about.index',
    path: `${PATH_PREFIX}/about`,
  },
  {
    name: 'company.teams.index',
    path: `${PATH_PREFIX}/teams`,
  },
  {
    name: 'company.follower.index',
    path: `${PATH_PREFIX}/follower`,
  },
  {
    name: 'company.showcase.category.index',
    path: `${PATH_PREFIX}/showcase`,
  },
  {
    name: 'company.showcase.category.index',
    path: `${PATH_PREFIX}/showcase/:path*`,
  },
  {
    name: 'company.showcase.product.index',
    path: `${PATH_PREFIX}/product/:productSlug`,
  },
  {
    name: 'company.announce.category.index',
    path: `${PATH_PREFIX}/announces`,
  },
  {
    name: 'company.announce.category.index',
    path: `${PATH_PREFIX}/announces/:path*`,
  },
  {
    name: 'company.announce.article.index',
    path: `${PATH_PREFIX}/announce`,
  },
  {
    name: 'company.announce.article.index',
    path: `${PATH_PREFIX}/announce/:articleSlug`,
  },
  {
    name: 'company.contacts.index',
    path: `${PATH_PREFIX}/contacts`,
  },
];
